import { hideDrawDeleteMenu, selectButton, quickSelectButton, revealTutorial } from "..";
import { triggerDrawControl } from "../..";
import { awaitTimer } from "../../experience/utils";
import { sendTrackingEvent } from "../../utils/events";

let draw_eraserButton = <HTMLButtonElement>document.querySelector('.draw_eraserButton');
let draw_penButton = <HTMLButtonElement>document.querySelector('.draw_penButton');
let draw_colourButton = <HTMLButtonElement>document.querySelector('.draw_colourButton');
let draw_undoButton = <HTMLButtonElement>document.querySelector('.draw_undoButton');
let draw_cameraButton = <HTMLButtonElement>document.querySelector('.draw_cameraButton');
let draw_deleteButton = <HTMLButtonElement>document.querySelector('.draw_deleteButton');
let draw_deleteMenuNoButton = <HTMLButtonElement>document.querySelector('.draw_deleteMenuNoButton');
let draw_deleteMenuYesButton = <HTMLButtonElement>document.querySelector('.draw_deleteMenuYesButton');
let draw_infoButton = <HTMLButtonElement>document.querySelector('.draw_infoButton');

export function initDraw() {
    draw_eraserButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped erase')
        console.log('eraser button pressed')
        triggerDrawControl('eraser');
        selectButton(draw_eraserButton);
        hideDrawDeleteMenu();
    });

    draw_penButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped to change marker type')
        console.log('pen button pressed')
        triggerDrawControl('pen');
        selectButton(draw_penButton)
        hideDrawDeleteMenu();
    });

    draw_colourButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped to change marker color')
        console.log('colour button pressed')
        quickSelectButton(draw_colourButton)
        triggerDrawControl('penSelection');
        awaitTimer(500).then(() => {
            selectButton(draw_penButton)
        })
        hideDrawDeleteMenu();
    });

    draw_undoButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped undo')
        triggerDrawControl('undo');
        quickSelectButton(draw_undoButton)
        hideDrawDeleteMenu();
    });

    draw_deleteButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped clear all')
        selectButton(draw_deleteButton)
        triggerDrawControl('delete')
    });

    draw_deleteMenuNoButton.addEventListener("touchend", () => {
        hideDrawDeleteMenu();
        triggerDrawControl('deleteMenuNo')
        selectButton(draw_penButton)
    });

    draw_deleteMenuYesButton.addEventListener("touchend", () => {
        hideDrawDeleteMenu();
        triggerDrawControl('clear');
        selectButton(draw_penButton)
    });

    draw_cameraButton.addEventListener("touchstart", () => {
        console.log('camera button pointer down')
        triggerDrawControl('cameraDown');
    });

    draw_cameraButton.addEventListener("touchend", () => {
        console.log('camera button pointerup')
        triggerDrawControl('cameraUp');
    });

    draw_infoButton.addEventListener("touchend", () => {
        sendTrackingEvent('User tapped (i) icon to review tutorial');
        console.log('info button pointerup')
        hideDrawDeleteMenu();
        selectButton(draw_penButton)
        triggerDrawControl('deleteMenuNo')
        revealTutorial();
        triggerDrawControl('pause')
    });
}